import React from 'react';
import { org2groups } from './queries';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import { ResourceType } from 'utils/types';
import useRelations from 'utils/hooks/useRelations';
import useAlerts from 'utils/hooks/useAlerts';
import MemberRelationTable from 'components/MemberRelationTable/MemberRelationTable';
import { createOrgResourceRelationData, useOrgGroupRelations } from './queries';


const OrgToGroupRelations = ({ breadcrumbs }) => {
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const { groups, groupRelationQuery, isLoading } = useOrgGroupRelations(orgId);

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: groupRelationQuery.refetch,
    queryKey: org2groups.org(createOrgResourceRelationData(ResourceType.Group, orgId)),
    onError: addErrorAlert
  });

  return (
    <ContentPage breadcrumb={breadcrumbs} help="organizations/relations">
      { alerts }
      <MemberRelationTable
        orgId={orgId}
        resources={groups}
        isLoading={isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToGroupRelations;
